// extracted by mini-css-extract-plugin
module.exports = {"removeResource":"DeleteButton-module__removeResource--35ZLW"};